export const OrderStatusString: Record<OrderStatus, string> = {
  1: "Successful and pending",
  2: "Available for pickup",
  3: "Delivered and completed",
  4: "Suspicious/Canceled",
};
